import { HardHat, Ruler, BadgeDollarSign, Megaphone, Landmark, Warehouse, Server, Building2 } from "lucide-react";
import { authStore } from "./api";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const MUSE_ID = "muse";
export const FAV_ID = "favorites";
export const fileUrl = (fid) => `${BACKEND}/api/files/${fid}/download?auth=${authStore.get("ali_token") || ""}`;
export const thumbUrl = (fid) => `${BACKEND}/api/files/${fid}/thumb?auth=${authStore.get("ali_token") || ""}`;
export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`);
/* 头像地址：后端返回 /api/avatars/{fid}（对象存储）或旧 base64 */
export const avatarSrc = (s) => (!s ? null : s.startsWith("/api/") ? `${BACKEND}${s}` : s);

/* 部门：中文 · 英文 · 徽标色 · 图标 · 主色（频道列表 / 频道头 / 成员徽标统一使用） */
export const DEPT = {
  // 工程部频道和成员徽标使用新英文名称，engineering 仍是后端部门 ID。
  engineering: ["工程部", "Construction", "bg-orange-100 text-orange-700", HardHat, "#f97316"],
  design: ["设计部", "Design", "bg-emerald-100 text-emerald-700", Ruler, "#10b981"],
  sales: ["销售部", "Sales", "bg-indigo-100 text-indigo-700", BadgeDollarSign, "#4F6BFF"],
  marketing: ["市场部", "Marketing", "bg-pink-100 text-pink-700", Megaphone, "#ec4899"],
  finance: ["财务部", "Finance", "bg-teal-100 text-teal-700", Landmark, "#0d9488"],
  warehouse: ["仓储部", "Warehouse", "bg-lime-100 text-lime-700", Warehouse, "#65a30d"],
  admin_it: ["行政/IT", "Admin & IT", "bg-cyan-100 text-cyan-700", Server, "#0891b2"],
  other: ["其他", "Other", "bg-slate-100 text-slate-600", Building2, "#64748b"],
};
export const deptLabel = (k, zh) => (DEPT[k] || DEPT.other)[zh ? 0 : 1];
export const deptCls = (k) => (DEPT[k] || DEPT.other)[2];
export const deptIcon = (k) => (DEPT[k] || DEPT.other)[3];
export const deptColor = (k) => (DEPT[k] || DEPT.other)[4];
export const deptTile = (k) => ({ backgroundColor: `${deptColor(k)}22`, color: deptColor(k) });

export const CH_TYPE = { dept: ["部门频道", "Departments"], project: ["我的项目", "My projects"], group: ["群组", "Groups"], topic: ["群组", "Groups"], dm: ["私聊", "Direct"] };

const AV = ["bg-violet-500", "bg-emerald-500", "bg-pink-500", "bg-slate-500", "bg-blue-500", "bg-amber-500", "bg-teal-500"];
export const avatarCls = (name) => AV[(name || "?").charCodeAt(0) % AV.length];
export const initials = (name) => { const s = (name || "?").trim(); return /[\u4e00-\u9fa5]/.test(s) ? s.slice(-2) : s.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase(); };

const LA = "America/Los_Angeles";
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: LA }) : "");
export const dayKey = (iso) => (iso ? new Date(iso).toLocaleDateString("en-CA", { timeZone: LA }) : "");
export const dayLabel = (key, zh) => {
  const today = new Date().toLocaleDateString("en-CA", { timeZone: LA });
  const y = new Date(Date.now() - 864e5).toLocaleDateString("en-CA", { timeZone: LA });
  if (key === today) return zh ? "今天" : "Today";
  if (key === y) return zh ? "昨天" : "Yesterday";
  return key;
};
export const relTime = (iso, zh) => {
  if (!iso) return "";
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return zh ? "刚刚" : "now";
  if (d < 3600) return `${Math.floor(d / 60)}m`;
  if (d < 86400) return `${Math.floor(d / 3600)}h`;
  return `${Math.floor(d / 86400)}d`;
};

export const PHASE_ZH = { "1-Pre-construction": "开工前", "2-Demolition": "拆除", "3-Foundation": "基础", "4-Rough MEP": "水电粗装", "5-Pre-Finishes": "精装前", "6-Finishes": "精装", "7-Final": "竣工验收", "8-Completed": "已完工" };
export const phaseLabel = (p, zh) => (!p ? "" : zh ? (PHASE_ZH[p] || p) : p);

export const linkify = (text) => (text || "").split(/(https?:\/\/[^\s]+|@[\w.\-\u4e00-\u9fa5]+)/g);
/* 语音时长 m:ss */
export const fmtDur = (s) => { const n = Math.max(0, Math.round(Number(s) || 0)); return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`; };
/* 频道列表 / toast 预览文案 */
export const msgPreview = (m, zh) => (m?.body || "").trim().slice(0, 80) || (m?.type === "voice" ? (zh ? `[语音 ${Math.round(m?.voice?.duration || 0)}"]` : `[voice ${Math.round(m?.voice?.duration || 0)}"]`) : m?.attachments?.length ? (zh ? "[附件]" : "[attachment]") : `[${m?.type || "msg"}]`);
